import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { ClientDepartmentStateClass } from "./interfaces/ClientDepartmentStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { sortData } from '../../../common/timeLiveFunction';

const initialState: ClientDepartmentStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    clientDepartmentList: [],
    sortOrder: 'asc',
    sortColumn: 'PartyDepartmentName',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        clientDepartment: ClientDepartmentStateClass
    }
}

export const getAccountEmployeeTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "EmployeeTypes/v2/getAccountEmployeeType",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/EmployeeTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )

export const getClientDepartmentsByAccountPartyIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/getClientDepartmentsByAccountPartyId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ClientDepartment/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ClientDepartment/PartyDepartmentById/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )


export const addAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/addAccountClientDepartment",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ClientDepartment/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/updateAccountClientDepartment",
        async (arg, thunkApi) => {
            const { AccountPartyDepartmentId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/ClientDepartment/" + AccountPartyDepartmentId, "PUT", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/deleteAccountClientDepartment",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/ClientDepartment/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const DeleteSelectedAccountClientDepartmentAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "ClientDepartment/v2/DeleteSelectedAccountClientDepartment",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ClientDepartment/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

const clientDepartmentSlice = createSlice({
    name: "clientDepartment",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.clientDepartmentList.findIndex((item) => item.AccountPartyDepartmentId == action.payload);
            const newArray = [...state.clientDepartmentList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.clientDepartmentList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.clientDepartmentList.findIndex((item) => item.AccountPartyDepartmentId == action.payload);
            const newArray = [...state.clientDepartmentList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.clientDepartmentList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.clientDepartmentList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.clientDepartmentList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.clientDepartmentList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.clientDepartmentList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.clientDepartmentList;
            state.clientDepartmentList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountEmployeeTypeAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountEmployeeTypeAsync.fulfilled, (state, { payload }) => {

            })
            .addCase(getAccountEmployeeTypeAsync.rejected, (state) => {
                state.status = "failed";
            })
            .addCase(getClientDepartmentsByAccountPartyIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getClientDepartmentsByAccountPartyIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (Object.keys(payload.Data).length === 0) {
                    state.clientDepartmentList = [];
                } else {
                    state.clientDepartmentList = payload.Data;
                    state.clientDepartmentList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getClientDepartmentsByAccountPartyIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (Object.keys(payload.Data[0]).length === 0) {
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(DeleteSelectedAccountClientDepartmentAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountClientDepartmentAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountClientDepartmentAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const { 
    resetSelectedRecordObjectInState, 
    checkedState, 
    unCheckedState, 
    checkedAllState, 
    unCheckedAllState, 
    checkAllCheckboxIsUncheckedState,
    updateSorting,
    updatePagination } = clientDepartmentSlice.actions
export const ClientDepartmentState = (state: RootState) => state.clientDepartment
export default clientDepartmentSlice.reducer


